import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MoneyInput } from "@/components/common/MoneyInput";
import { MODO_COMISION_ARR } from "@/lib/arrendamiento";

/** Simulador · Arrendamiento: valor del bien, enganche, residual y plazo. Capital y renta los calcula el backend. */
export function ArrendamientoSimForm({ form, set, producto }) {
  const plazos = (Array.isArray(producto?.plazos_permitidos) ? producto.plazos_permitidos : []).map(Number);
  const rmin = producto?.residual_min_pct, rmax = producto?.residual_max_pct;
  return (
    <div className="space-y-3 rounded-md border border-teal-200 bg-teal-50/40 p-3" data-testid="sim-arr-form">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-teal-900">Datos del bien</p>
      <div>
        <Label className="mb-1 block text-xs font-medium text-slate-600">Valor del bien sin IVA</Label>
        <MoneyInput data-testid="sim-arr-valor-bien" value={form.valor_bien_sin_iva} onChange={(v) => set("valor_bien_sin_iva", v)} />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="mb-1 block text-xs font-medium text-slate-600">Enganche</Label>
          <MoneyInput data-testid="sim-arr-enganche" value={form.enganche} onChange={(v) => set("enganche", v)} />
        </div>
        <div>
          <Label className="mb-1 block text-xs font-medium text-slate-600">
            Valor residual (%) <span className="font-normal text-slate-400">({rmin ?? "—"}% – {rmax ?? "—"}%)</span>
          </Label>
          <Input data-testid="sim-arr-residual" type="number" value={form.residual_pct}
            onChange={(e) => set("residual_pct", e.target.value)} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <Label className="mb-1 block text-xs font-medium text-slate-600">Plazo ({String(form.periodicidad || "").toLowerCase()})</Label>
          {plazos.length > 0 ? (
            <Select value={String(form.plazo)} onValueChange={(v) => set("plazo", Number(v))}>
              <SelectTrigger data-testid="sim-arr-plazo"><SelectValue /></SelectTrigger>
              <SelectContent>{plazos.map((p) => <SelectItem key={p} value={String(p)}>{p}</SelectItem>)}</SelectContent>
            </Select>
          ) : (
            <Input data-testid="sim-arr-plazo" type="number" value={form.plazo} onChange={(e) => set("plazo", e.target.value)} />
          )}
        </div>
        <div className="text-[11px] text-slate-500">
          <p>IVA de las rentas: <b className="text-slate-700" data-testid="sim-arr-iva-rentas">{producto?.iva_rentas === "exento" ? "Exento" : "16%"}</b></p>
          <p>Comisión: <b className="text-slate-700">{MODO_COMISION_ARR[producto?.comision_cobro_modo] || MODO_COMISION_ARR.separado}</b></p>
        </div>
      </div>
      <p className="text-[11px] text-slate-500">
        Rentas fijas que amortizan el capital (valor sin IVA − enganche) menos el valor residual; el residual se
        paga al término, con la opción terminal.
      </p>
    </div>
  );
}
